export default __webpack_public_path__ + "static/media/senti.waterworks.30d11488.svg";